module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-03.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-03.png
// module id = 1378
// module chunks = 0